// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Dialog = require("../react-mui-components/Expln_React_Dialog.res.js");
var Expln_utils_promise = require("../Expln_utils_promise.res.js");
var JsxPPXReactSupportU = require("rescript/lib/js/jsxPPXReactSupportU.js");

function useModalRef() {
  return React.useRef(null);
}

function modalRefToModalMethods(modalRef) {
  var modalMethods = modalRef.current;
  if (modalMethods == null) {
    return Js_exn.raiseError("modalRef.current is null");
  } else {
    return modalMethods;
  }
}

function openModal(modalRef, render) {
  return modalRefToModalMethods(modalRef).openModal(render);
}

function openModalFullScreen(modalRef, render) {
  return modalRefToModalMethods(modalRef).openModalFullScreen(render);
}

function updateModal(modalRef, modalId, render) {
  modalRefToModalMethods(modalRef).updateModal(modalId, render);
}

function closeModal(modalRef, modalId) {
  modalRefToModalMethods(modalRef).closeModal(modalId);
}

function createInitialState() {
  return {
          nextId: 0,
          modals: []
        };
}

function openModalPriv(st, fullScreen, render) {
  var id = String(st.nextId);
  return [
          {
            nextId: st.nextId + 1 | 0,
            modals: st.modals.concat([{
                    id: id,
                    fullScreen: fullScreen,
                    render: render
                  }])
          },
          id
        ];
}

function Expln_React_Modal(props) {
  var match = React.useState(createInitialState);
  var setState = match[1];
  props.modalRef.current = React.useMemo((function () {
          return {
                  openModal: (function (render) {
                      return Expln_utils_promise.promise(function (rlv) {
                                  setState(function (prev) {
                                        var match = openModalPriv(prev, false, render);
                                        rlv(match[1]);
                                        return match[0];
                                      });
                                });
                    }),
                  openModalFullScreen: (function (render) {
                      return Expln_utils_promise.promise(function (rlv) {
                                  setState(function (prev) {
                                        var match = openModalPriv(prev, true, render);
                                        rlv(match[1]);
                                        return match[0];
                                      });
                                });
                    }),
                  updateModal: (function (modalId, render) {
                      setState(function (__x) {
                            return {
                                    nextId: __x.nextId,
                                    modals: __x.modals.map(function (m) {
                                          if (m.id === modalId) {
                                            return {
                                                    id: m.id,
                                                    fullScreen: m.fullScreen,
                                                    render: render
                                                  };
                                          } else {
                                            return m;
                                          }
                                        })
                                  };
                          });
                    }),
                  closeModal: (function (modalId) {
                      setState(function (__x) {
                            return {
                                    nextId: __x.nextId,
                                    modals: __x.modals.filter(function (m) {
                                          return m.id !== modalId;
                                        })
                                  };
                          });
                    })
                };
        }), []);
  return React.createElement(React.Fragment, {
              children: Caml_option.some(match[0].modals.map(function (modal) {
                        return JsxPPXReactSupportU.createElementWithKey(modal.id, Expln_React_Dialog.make, {
                                    opn: true,
                                    fullScreen: modal.fullScreen,
                                    maxWidth: modal.fullScreen ? undefined : "xl",
                                    children: modal.render()
                                  });
                      }))
            });
}

var make = Expln_React_Modal;

exports.useModalRef = useModalRef;
exports.openModal = openModal;
exports.openModalFullScreen = openModalFullScreen;
exports.updateModal = updateModal;
exports.closeModal = closeModal;
exports.make = make;
/* react Not a pure module */
